<template>
  <notes
    description="General Notes related to this Vendor"
    :notableEntity="notableEntity"
  />
</template>
<script>
import notes from "@/components/Handi/Notes/Notes";

export default {
  props: {
    vendor: Object
  },

  components: {
    notes
  },

  data() {
    return {
      entityType: "vendor"
    };
  },

  computed: {
    notableEntity() {
      return {
        entityType: this.entityType,
        entityId: this.vendor.id
      };
    }
  }
};
</script>
<style lang="scss" scoped></style>
